import i18n from '../../language/index'
import {
  historys_init
} from '@/base/base';
import {
  create_title
} from '@/base/titleData';
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
  },
  pc_widgets_infor: {
    shadow: {
      radio_val: 'default',
      default: {
        size: 6,
        color: 'rgba(0, 0, 0,0.2)'
      },
      custom: {
        size: 6,
        color: 'rgba(0, 0, 0,0.2)'
      }
    },
    set_style: {
      background: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
        custom: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        }
      },
    },
    //标题对象
    title: create_title('Development path'),
    //每行个数
    col_num: {
      radio_val: 'default',
      default: {
        value: 4,
      },
      custom: {
        value: 4,
      }
    },
    titleFont: {
      radio_val: 'default',
      default: {
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
    },
  },
  mb_widgets_infor: {
      title: create_title('Development path'),
  },
  listArr: {
    list: [...historys_init({
      title: i18n.t('widgets_basic_development_history_edit_497'),
      summary: i18n.t('widgets_basic_development_history_style_500')
    })],
    richTextTitle: i18n.t('widgets_basic_development_history_style_500'),// 发展历程标题
    module_style: 0, // 样式选择
    is_loop: 'default', // 首尾相连：'default'关闭, 'custom'开启
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_development_history/style.js